import React from "react";
import { Reveal } from "./motion/Reveal";
import { TextReveal } from "./motion/TextReveal";

// Inner-page hero band (deep green) with image accent.
export const PageHero = ({ overline, title, subtitle, image }) => (
  <section
    data-testid="page-hero"
    className="relative flex min-h-[62vh] items-end overflow-hidden bg-brand-green pt-32"
  >
    {image && (
      <div className="absolute inset-0">
        <img src={image} alt="" className="h-full w-full object-cover opacity-25" loading="eager" />
        <div className="absolute inset-0 bg-brand-green/70" />
      </div>
    )}
    <div className="relative z-10 mx-auto w-full max-w-[1400px] px-6 pb-16 md:px-12 md:pb-24">
      {overline && (
        <Reveal variant="fade" className="mb-6 text-xs uppercase tracking-[0.25em] text-brand-gold">
          {overline}
        </Reveal>
      )}
      <h1 className="max-w-4xl font-serif text-5xl font-light leading-[1.05] tracking-tight text-white md:text-6xl lg:text-7xl">
        <TextReveal text={title} />
      </h1>
      {subtitle && (
        <Reveal variant="up" delay={0.2} className="mt-6 max-w-2xl text-lg font-light text-white/75">
          {subtitle}
        </Reveal>
      )}
    </div>
  </section>
);

export const Overline = ({ children, className = "" }) => (
  <span className={`text-xs uppercase tracking-[0.25em] text-brand-gold ${className}`}>
    {children}
  </span>
);

export const SectionTitle = ({ children, className = "", light = false }) => (
  <h2
    className={`font-serif text-4xl font-light leading-tight tracking-tight md:text-5xl ${
      light ? "text-white" : "text-brand-green"
    } ${className}`}
  >
    {children}
  </h2>
);
